//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MIcon, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Components/Toolkit/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import {FileData} from '../Api/ControllerTypes/FileTypes';
import FileListControl from '../Components/FileListControl';
import {IMsalContext} from '@azure/msal-react';
import MSpacer from '../Toolkit/Components/Controls/Spacer';

//endregion

/** */
type Props = {
    onSelectionChange?: (newSelection: FileData[]) => void;
    useEmailData?: boolean;
    msalContext: IMsalContext;
    onDialogClose: (cancelled: boolean) => void;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    pageTitle: string;
    parentId: string;
    promptText: string;
}

/** */
class FileSelectionDialog extends MComponent<Props, State> {

    private CheckIcon: MIcon = {name: 'pi pi-check-square', color: 'mcolor-info'};

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.cancel_Click = this.cancel_Click.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            pageTitle: 'File Selection',
            parentId: '',
            promptText: ''
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(requestId: string, promptText: string, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.parentId = requestId;
            draft.promptText = promptText;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        if(this.props.onDialogClose !== null) {
            this.props.onDialogClose!(false);
        }
        this.safeSetState(s => s.visible = false);
    }

    private cancel_Click() {
        if(this.props.onDialogClose !== null) {
            this.props.onDialogClose!(true);
        }
        this.safeSetState(s => s.visible = false);
    }

    private onSelectionChange(newSelection: FileData[]) {
        if(this.props.onSelectionChange !== undefined) {
            this.props.onSelectionChange(newSelection);
        }

    }

    private getDialogTemplate(): ReactNode {
        return (
                <div className="formgrid grid">
                    <div style={{width: "50vw"}}>
                        {this.state.promptText}
                    </div>
                    <div className="col-12 md:col-12">
                        <FileListControl parentId={this.state.parentId}
                                         selectionOnly={true}
                                         msalContext={this.props.msalContext}
                                         onSelectionChange={this.onSelectionChange}
                                         useEmailData={this.props.useEmailData}
                        />
                    </div>
                </div>
        );
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={false}
                         onClick={this.ok_Click}/>
                <MSpacer/>
                <MButton label="Cancel"
                         color="primary"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.cancel_Click}/>
            </div>
        );
    }
    /** */
    public render(): ReactElement {

        return (
            <Dialog title={this.state.pageTitle}
                    content={this.getDialogTemplate()}
                    icon={this.CheckIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}
                    style={{width: "60vw"}}
            />
        );
    }
}

export default FileSelectionDialog;
